import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { of } from 'rxjs';
import 'jquery';
import 'bootstrap/dist/js/bootstrap.min.js';
import { Observable } from 'rxjs';

@Injectable()
export class DataResolver implements Resolve<any> {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.error(route);
    return of({ res: 'I am data' });
  }
}

// an array of services to resolve routes with data
export const APP_RESOLVER_PROVIDERS = [
  DataResolver
];